/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Rename_LabelInputs */

const en_explorer_info_rename_label = /** @type {(inputs: Explorer_Info_Rename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New name`)
};

const fr_explorer_info_rename_label = /** @type {(inputs: Explorer_Info_Rename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau nom`)
};

const de_explorer_info_rename_label = /** @type {(inputs: Explorer_Info_Rename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Name`)
};

const it_explorer_info_rename_label = /** @type {(inputs: Explorer_Info_Rename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo nome`)
};

const ru_explorer_info_rename_label = /** @type {(inputs: Explorer_Info_Rename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новое название`)
};

const es_explorer_info_rename_label = /** @type {(inputs: Explorer_Info_Rename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo nombre`)
};

const zh_cn2_explorer_info_rename_label = /** @type {(inputs: Explorer_Info_Rename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新名称`)
};

const ja_explorer_info_rename_label = /** @type {(inputs: Explorer_Info_Rename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい名前`)
};

const hi_explorer_info_rename_label = /** @type {(inputs: Explorer_Info_Rename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया नाम`)
};

const pt_pt2_explorer_info_rename_label = /** @type {(inputs: Explorer_Info_Rename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo nome`)
};

/**
* | output |
* | --- |
* | "New name" |
*
* @param {Explorer_Info_Rename_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_rename_label = /** @type {((inputs?: Explorer_Info_Rename_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Rename_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_rename_label(inputs)
	if (locale === "de") return de_explorer_info_rename_label(inputs)
	if (locale === "it") return it_explorer_info_rename_label(inputs)
	if (locale === "ru") return ru_explorer_info_rename_label(inputs)
	if (locale === "es") return es_explorer_info_rename_label(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_rename_label(inputs)
	if (locale === "ja") return ja_explorer_info_rename_label(inputs)
	if (locale === "hi") return hi_explorer_info_rename_label(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_rename_label(inputs)
	return en_explorer_info_rename_label(inputs)
});